/**
 * Banner 1062 — KUK programme referral band.
 *
 * The band itself is section level; the USP tiles under it are `metadata`, so their
 * number is not fixed at the reference's three.
 *
 * Every field maps to a column that already exists on `banner` — the variant adds no
 * schema of its own beyond widening `banner.variant`.
 */

export const BANNER_1062_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "USP tiles",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_image: "",
    meta_alt_image: "",
    meta_title: "",
    meta_background_color: "#6C276A",
    meta_text_color: "#FFFFFF",
    meta_priority: 1,
    meta_status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "background_image",
      label: "Artwork (1080px and up)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      fieldName: "background_image_mobile",
      label: "Artwork (below 1080px)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — uses the desktop artwork if empty",
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Artwork alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      fieldName: "title",
      label: "Headline",
      value: "Chance to earn up to {50%} of your course fee back",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 2,
      description: "Wrap a phrase in { } to paint a highlight chip behind it.",
      defaultValue: "Chance to earn up to {50%} of your course fee back",
    },
    {
      fieldName: "title_color",
      label: "Headline colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_highlight_color",
      label: "Highlight chip colour",
      value: "#E26C24",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#E26C24",
    },
    {
      fieldName: "description",
      label: "Supporting line",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 2,
      defaultValue: "",
    },
    {
      fieldName: "description_color",
      label: "Supporting line colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "apply_now_show",
      label: "Show the CTA",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_text",
      label: "CTA text",
      value: "Start referring Now!",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Start referring Now!",
    },
    {
      fieldName: "apply_now_is_cta",
      label: "CTA opens the lead form",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      description: "Off → link to the URL below instead.",
      defaultValue: true,
    },
    {
      fieldName: "apply_now_link",
      label: "CTA link (when it is not a lead form)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/launchpad",
      defaultValue: "",
    },
    {
      fieldName: "apply_now_color",
      label: "CTA label colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "icon",
      label: "CTA icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — upload, or type an icon name",
      defaultValue: "",
    },
    {
      fieldName: "gradient_color_1",
      label: "CTA gradient — start",
      value: "#B0325E",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#B0325E",
    },
    {
      fieldName: "gradient_color_2",
      label: "CTA gradient — end",
      value: "#FAA681",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FAA681",
    },
    {
      fieldName: "gradient_color_3",
      label: "CTA gradient — angle",
      value: "47deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "47deg",
      defaultValue: "47deg",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Tile image",
      fieldName: "meta_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      defaultValue: "",
    },
    {
      header: "Image alt",
      fieldName: "meta_alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Tile copy",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      rows: 2,
      placeholder: "e.g. Earn Up to ₹20,000+",
      defaultValue: "",
    },
    {
      header: "Tile fill",
      fieldName: "meta_background_color",
      value: "#6C276A",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#6C276A",
    },
    {
      header: "Tile text colour",
      fieldName: "meta_text_color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [],
};
